export const CartPhase = {
    DETAIL: 'detail',
    SHIPPING_AND_PAYMENT: 'shipping_and_payment',
    DELIVERY: 'delivery',
    SUMMARY: 'summary',
} as const

export type _CartPhases = { [K in typeof CartPhase[keyof typeof CartPhase]]: any }
